<template>
    <dialogBox >
        <template v-slot:title>{{ $t('Comment') }}</template>
        <template v-slot:body>
            <div class="mb-3">
                <span class="fs-14 badge bg-info copy mb-2" @click="this.form.comment = this.$t('3daysNoAnswer')" style="margin-right: 5px;">{{ $t('3daysNoAnswer') }}</span>
                <span class="fs-14 badge bg-info copy mb-2" @click="this.form.comment = this.$t('notInterest')" style="margin-right: 5px;">{{ $t('notInterest') }}</span>
                <span class="fs-14 badge bg-info copy mb-2" @click="this.form.comment = this.$t('Не відповів')" style="margin-right: 5px;">{{ $t('Не відповів') }}</span>
            </div>
            <div class="mb-3">
                <label class="form-label">{{ $t('Comment') }}</label>
                <textarea class="form-control" rows="3" v-model="form.comment" ></textarea>
            </div>
            <div class="form-check" v-if="this.obj.monitor === true">
                <input class="form-check-input" type="checkbox" v-model="this.form.commentInMonitoring" id="flexCheckDefault">
                <label class="form-check-label" for="flexCheckDefault">
                    {{ this.$t("copyInMonitoring") }}
                </label>
            </div>
        </template>
        <template v-slot:footer-bottom>
            <button class="btn link-success fw-medium"  @click="this.$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('cancel') }} </button>
            <button 
                type="button" 
                class="btn btn-primary" 
                @click="toClose"
            >
                {{ $t('Add') }}
            </button>
        </template>
    </dialogBox>
</template>

<script>
import dialogBox from '@/components/modal/dialog'
import "flatpickr/dist/flatpickr.min.css";
import Vueflatpickr from "vue-flatpickr-component";

export default{
    components: {
        dialogBox,
        flatpickr: Vueflatpickr
    },
    props: ['obj'],
    data(){
        return{
            form: {
                commentInMonitoring: false,
                comment: '',
            },
        }
    },
    created() {
        console.log(this.obj)
    },
    methods: {
        toClose(){
            if(this.form.comment == '') {
                this.$toast.error(this.$t('enterComment'))
            } else {
                this.$emit('toClose', this.obj.requestId, this.form)
                this.$emit('close')
            }
        }
    }
}
</script>